export default "__VITE_PUBLIC_ASSET__13eadec9__"